import { makeStyles, Step, StepConnector, StepIconProps, StepLabel, Stepper } from "@material-ui/core";
import * as React from 'react';

export interface WorkflowStepProps {
    title: string,
    description: string,
    icon?: React.ElementType
}
export interface WorkflowProps {
    steps: WorkflowStepProps[],
    activeStep: number
}

export const CreateWorkflow = ({ steps, activeStep, ...rest }: WorkflowProps) => {
    return <Workflow steps={ steps } activeStep={ activeStep } { ...rest } />
}

export const Workflow = ({ steps, activeStep, ...rest }: WorkflowProps) => {
    const classes = useWorkflowStyles(rest);

    return steps.length ?
        <Stepper classes={ classes } alternativeLabel activeStep={ activeStep } connector={ <WorkflowConnector activeStep={ activeStep } /> }>
            { steps.map(step => (
                <Step key={ step.title }>
                    <WorkflowStepLabel step={ step } />
                </Step>
            )) }
        </Stepper>
        : <div />
}

const useWorkflowStyles = makeStyles({
    root: {
        width: '100%',
        background: 'transparent',
        padding: 0
    }
});

const WorkflowStepLabel = ({ step, ...rest }: { step: WorkflowStepProps }) => {
    const classes = useWorkflowStepLabelStyles(rest);
    return (
        <StepLabel StepIconComponent={ step.icon || WorkflowStepDefaultIcon } { ...rest }>
            <span className={ classes.title }>{ step.title }</span><br />
            <span className={ classes.description }>{ step.description }</span>
        </StepLabel>
    );
}

const useWorkflowStepLabelStyles = makeStyles({
    title: {
        fontWeight: 800,
        color: (props: any) => props.active ? '#3d6889' : (props.completed ? '#57bf90' : '')
    },
    description: {
        display: 'block',
        marginLeft: 'auto',
        marginRight: 'auto',
        width: 100,
        wordWrap: 'break-word',
        marginTop: 10,
        color: (props: any) => props.active ? '#3d6889' : (props.completed ? '#57bf90' : '')
    }
});

const WorkflowStepDefaultIcon = ({ active, completed, ...rest }: Partial<StepIconProps>) => {
    const classes = useWorkflowStepDefaultIconStyles(rest);
    let classNames = classes.root;
    let inactive = !active && !completed;

    if (active) classNames += ' ' + classes.active;
    if (completed) classNames += ' ' + classes.completed;
    if (inactive) classNames += ' ' + classes.circle;

    return (
        <span className={ classNames }>
            <span className={ classes.text }>{ rest.icon }</span>
        </span>
    );
}

const useWorkflowStepDefaultIconStyles = makeStyles({
    root: {
        display: 'flex',
        alignItems: 'center',
        width: '28px',
        height: '28px',
        borderRadius: '50%',
        border: '2px solid'
    },
    active: {
        color: 'white',
        backgroundColor: '#3d6889',
        borderColor: '#3d6889'

    },
    circle: {
        color: '#bcc4c9',
        borderColor: '#bcc4c9'
    },
    completed: {
        backgroundColor: '#57bf90',
        color: 'white',
        borderColor: '#57bf90'
    },
    text: {
        width: '20px',
        paddingLeft: 4,
        fontSize: 13,
        textAlign: 'center',
        fontStyle: 'bold'
    }
});

const WorkflowConnector = (props) => {
    var classes = useWorkflowConnectorStyles(props);
    var { activeStep, ...rest } = props;
    return <StepConnector classes={ classes } { ...rest } />
};

const useWorkflowConnectorStyles = makeStyles({
    alternativeLabel: {
        left: 'calc(-50% + 14px)',
        right: 'calc(50% + 14px)'
    },
    active: {
        '& $line': {
            backgroundColor: '#57bf90',
            backgroundImage: 'linear-gradient(to right, #57bf90 50%, #3d6889 50%)'
        },
    },
    completed: {
        '& $line': {
            backgroundColor: '#57bf90',
        },
    },
    line: {
        borderWidth: 0,
        height: 5,
        backgroundColor: '#bcc4c9',
        backgroundImage: (props: any) => props.activeStep + 1 === props.index ? 'linear-gradient(to right, #3d6889 50%, #bcc4c9 50%)' : ''
    }
});